import "core-js/modules/es6.object.assign.js";

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { PureComponent } from 'react';

var GitHubButton =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(GitHubButton, _PureComponent);

  function GitHubButton(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.$ =
    /*#__PURE__*/
    React.createRef();
    _this._ =
    /*#__PURE__*/
    React.createRef();
    return _this;
  }

  var _proto = GitHubButton.prototype;

  _proto.render = function render() {
    return (
      /*#__PURE__*/
      React.createElement('span', {
        ref: this.$
      },
      /*#__PURE__*/
      React.createElement('a', Object.assign({}, this.props, {
        ref: this._
      }), this.props.children))
    );
  };

  _proto.componentDidMount = function componentDidMount() {
    this.paint();
  };

  _proto.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate() {
    this.reset();
    return null;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.paint();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.reset();
  };

  _proto.paint = function paint() {
    var _this2 = this;

    var _ = this.$.current.appendChild(document.createElement('span'));

    import(
    /* webpackMode: "eager" */
    'github-buttons').then(function (_ref) {
      var render = _ref.render;
      render(_.appendChild(_this2._.current), function (el) {
        try {
          _.parentNode.replaceChild(el, _);
        } catch (_) {}
      });
    });
  };

  _proto.reset = function reset() {
    this.$.current.replaceChild(this._.current, this.$.current.lastChild);
  };

  return GitHubButton;
}(PureComponent);

export default GitHubButton;